/**
 * @class
 */
var AitiProductVariantGroupOption = function(group, data) {

    let _this = this;

    this._group = group;
    this._data = data;

    this.getGroup = function() {
        return this._group;
    };

    this.getId = function() {
        return this._data['id'];
    };

    this.getItemId = function() {
        return this._data['itemId'];
    };

    this.getLabel = function() {
        return this._data['label'];
    };

    this.isCurrent = function() {
        return this._data['current'];
    };

    this.setCurrent = function(current) {
        this._data['current'] = current;
        return this;
    };
};

export default AitiProductVariantGroupOption;
